import { api } from './api.service';

export interface TkwResultDay {
  /** ISO date yyyy-mm-dd */
  date: string;
  tkw: string;
  admin: string;
}

export interface TkwResponse {
  success: boolean;
  version: string;
  results: TkwResultDay[];
}

/**
 * Generates ALBIS daily passwords for the given version + date. The api
 * always returns 7 consecutive days; the ui decides how many to render.
 */
export async function generateTkw(version: string, date?: string): Promise<TkwResponse> {
  const body: Record<string, unknown> = { version };
  if (date) {
    body.date = date;
  }
  return api<TkwResponse>('/api/module/albis-tkw', {
    method: 'POST',
    body
  });
}
